import { Home, MapPin, CalendarCheck, Phone, MessageSquare } from "lucide-react";
import { BOOKSY_URL } from "@/lib/config";

const PHONE = "3183552116";
const PHONE_LABEL = "(318) 355-2116";

const STEPS = [
  { icon: CalendarCheck, title: "Book your slot", text: "Pick a time on Booksy, or call or text to set it up." },
  { icon: MapPin, title: "Send your address", text: "Let us know where to pull up and any parking details." },
  { icon: Home, title: "We bring the shop", text: "Clippers, razors, cape and cleanup — you just take a seat." },
];

const InfoBlock = ({ label, value, testid }) => (
  <div data-testid={testid} className="border border-white/10 p-6">
    <div className="text-xs tracking-[0.3em] uppercase text-white/40 mb-2">{label}</div>
    <div className="font-mono text-lg uppercase text-[#CCFF00]">{value}</div>
  </div>
);

export default function HouseCall() {
  return (
    <section id="house-call" data-testid="house-call-section" className="py-24 md:py-32 px-4 md:px-8 border-y border-white/10">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <span className="h-px w-12 bg-[#FF3333]" />
            <span className="text-xs tracking-[0.3em] uppercase font-bold text-[#FF3333]">Mobile Barber</span>
          </div>
          <h2 className="font-display font-black uppercase text-5xl md:text-7xl tracking-tighter leading-none mb-8">
            House <span className="italic text-[#FF3333]">Calls</span>
          </h2>
          <p className="text-white/60 font-light leading-relaxed max-w-lg mb-10">
            Can't make it to the shop? We come to you. Home, office, event or game day — get the same sharp
            cut without leaving your spot.
          </p>
          <div className="grid sm:grid-cols-2 gap-4 mb-10">
            <InfoBlock testid="house-call-area" label="Travel Area" value="Monroe, West Monroe & surrounding areas" />
            <InfoBlock testid="house-call-price" label="Price" value="Price on request" />
          </div>
          <div className="flex flex-col sm:flex-row gap-4">
            <a data-testid="house-call-booksy-btn" href={BOOKSY_URL} target="_blank" rel="noopener noreferrer" className="bg-[#FF3333] street-btn font-bold uppercase tracking-widest text-sm px-8 py-5 hover:bg-[#FF5C5C] text-center">
              Book on Booksy →
            </a>
            <a data-testid="house-call-call-btn" href={`tel:${PHONE}`} className="flex items-center justify-center gap-2 border border-white/30 text-white font-bold uppercase tracking-widest text-sm px-8 py-5 hover:bg-white/5 hover:border-white transition-colors">
              <Phone className="w-4 h-4" /> Call
            </a>
            <a data-testid="house-call-text-btn" href={`sms:${PHONE}`} className="flex items-center justify-center gap-2 border border-white/30 text-white font-bold uppercase tracking-widest text-sm px-8 py-5 hover:bg-white/5 hover:border-white transition-colors">
              <MessageSquare className="w-4 h-4" /> Text
            </a>
          </div>
          <div data-testid="house-call-phone" className="font-mono text-sm text-white/50 mt-4">{PHONE_LABEL}</div>
        </div>

        <ol className="self-center space-y-4">
          {STEPS.map((s, i) => (
            <li key={s.title} data-testid={`house-call-step-${i + 1}`} className="flex gap-6 border border-white/10 p-6 md:p-8 hover:border-[#FF3333] transition-colors">
              <span className="font-display font-black text-4xl text-transparent" style={{ WebkitTextStroke: "1px #FF3333" }}>0{i + 1}</span>
              <div>
                <div className="flex items-center gap-3 mb-2">
                  <s.icon className="w-5 h-5 text-[#FF3333]" />
                  <h3 className="font-display text-xl md:text-2xl font-bold uppercase tracking-tight">{s.title}</h3>
                </div>
                <p className="text-white/60 font-light">{s.text}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
